export default "__VITE_ASSET__BzeFuBwS__"